import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  subtitle: {
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  stepField: {
    margin: '0 auto 5rem',
  },
  selectedFile: {
    margin: '0 0.5rem',
    color: colors.neutral[900],
    wordBreak: 'break-all',
    lineHeight: '3rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
